module.exports = __webpack_public_path__ + "img/accessory-2@2x.9020befa.png";